$( document ).ready( function() {

    //toggle footer menus on mobile
    $('footer #footer_menu_section .footer_menu_section__column__title .footer_menu_arrow').click( function() {

        const column = $(this).parents('.footer_menu_section__column');

        //show items
        if ( !$(this).hasClass('active') ) {

            //remove all active
            $('.footer_menu_section__column').each( function(index) {

                const arrow_el = $(this).find('.footer_menu_section__column__title .footer_menu_arrow');
                
                if ( arrow_el.hasClass('active') ) {

                    arrow_el.removeClass('active');
                    $(this).removeClass('column_opened');
                    $(this).find('.footer_menu_section__links__wrapper').slideUp("400");
                }            
            });

            //show items
            $(this).addClass('active');
            column
                .addClass('column_opened')
                .find('.footer_menu_section__links__wrapper').slideDown("400");

        //hide items
        } else {
                        
            $(this).removeClass('active');
            column
                .removeClass('column_opened')
                .find('.footer_menu_section__links__wrapper').slideUp("400");
        }

        
    });

    //on window resize, show/hide items
    $(window).resize(function(){

        const winWidth = window.innerWidth;

        if ( winWidth > 767 ) {
    
            //remove all active
            $('.footer_menu_section__column').each( function(index) {

                const linksWrapper = $(this).find('.footer_menu_section__links__wrapper');

                $(this).find('.footer_menu_section__column__title .footer_menu_arrow').removeClass('active');
                $(this).removeClass('column_opened');
                
                if ( linksWrapper.css('display') == 'none') {
                    linksWrapper.show();
                }           
            });

        } else {

             //hide all items
             $('.footer_menu_section__column').each( function(index) {

                const linksWrapper = $(this).find('.footer_menu_section__links__wrapper');

                if ( linksWrapper.css('display') == 'block') {
                    linksWrapper.hide();
                }           
            });
        }
    });   
    
});